<template>
    <div class='sk__listCard'>
        <template v-for='item in 3'>
            <div class='sk__listCard-item'>
                <div class='sk__listCard-item-description'>
                    <div class='sk__listCard-item-description-wrapper'>
                        <div class='sk__listCard-item-description-elem-1 elem'></div>
                        <div class='sk__listCard-item-description-elem-2 elem'></div>
                        <div class='sk__listCard-item-description-elem-3 elem'></div>
                        <div class='sk__listCard-item-description-elem-4 elem'></div>
                        <div class='sk__listCard-item-description-elem-5 elem'></div>
                        <div class='sk__listCard-item-description-elem-6 elem'></div>
                        <div class='sk__listCard-item-description-elem-7 elem'></div>
                    </div>
                </div>
                <div class='sk__listCard-item-view'>
                    <div class='sk__listCard-item-view-image elem'></div>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
export default {};
</script>

<style scoped lang='less'>
@import "theme/moydom/less/variables.less";

.sk {
    &__listCard {
        &-item {
            display: flex;
            width: 100%;
            border: 1px solid #EAEDF0;
            border-radius: 8px;
            margin-bottom: 20px;

            @media (max-width: 680px) {
                flex-direction: column-reverse;
            }

            &-description {
                width: 100%;
                padding: 20px;
                border-right: 1px solid #D9D9D9;

                @media (max-width: 680px) {
                    border-right: 1px solid transparent;
                }

                &-elem-1 {
                    border-radius: 20px;
                    height: 24px;
                    width: 156px;

                    @media (max-width: 680px) {
                        width: 48px;
                        height: 22px;
                    }
                }

                &-elem-2 {
                    border-radius: 20px;
                    height: 24px;
                    margin-top: 20px;
                    width: 350px;
                    @media (max-width: @screen-sm) {
                        width: 266px;
                    }

                    @media (max-width: 680px) {
                        margin-top: 15px;
                        width: 100%;
                    }
                }

                &-elem-3 {
                    border-radius: 20px;
                    height: 18px;
                    margin-top: 20px;
                    width: 390px;

                    @media (max-width: @screen-sm) {
                        width: 330px;
                    }

                    @media (max-width: 680px) {
                        margin-top: 15px;
                        width: 100%;
                        height: 20px;
                    }
                }

                &-elem-4 {
                    border-radius: 20px;
                    height: 16px;
                    margin-top: 20px;
                    width: 100px;

                    @media (max-width: 680px) {
                        margin-top: 15px;
                        width: 100%;
                    }
                }

                &-elem-5 {
                    border-radius: 20px;
                    height: 22px;
                    margin-top: 20px;
                    width: 65px;

                    @media (max-width: 680px) {
                        width: 100%;
                        border-radius: 4px;
                        height: 40px;
                    }
                }

                &-elem-6 {
                    border-radius: 20px;
                    height: 20px;
                    margin-top: 20px;
                    width: 235px;
                    @media (max-width: 680px) {
                        display: none;
                    }
                }

                &-elem-7 {
                    border-radius: 20px;
                    height: 23px;
                    margin-top: 20px;
                    width: 140px;
                    @media (max-width: 680px) {
                        display: none;
                    }
                }

                &-wrapper {
                    max-width: 390px;

                    @media (max-width: 680px) {
                        max-width: 100%;
                    }
                }
            }

            &-view {
                padding: 20px;
                display: flex;
                flex-direction: column;

                &-image {
                    width: 300px;
                    height: 300px;
                    border-radius: 4px;

                    @media (max-width: @screen-md) {
                        width: 240px;
                    }

                    @media (max-width: 680px) {
                        width: 100%;
                        height: 320px;
                    }
                }
            }
        }
    }
}

.elem {
    background: #EAEDF0;
    position: relative;
    overflow: hidden;

    &::after {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        transform: translateX(-100%);
        background: linear-gradient(90deg,
        transparent 0%,
        #c3c3c361 30%,
        transparent 100%);
        animation: load 2s infinite;
        content: '';
    }
}


@keyframes load {
    100% {
        transform: translateX(100%);
    }
}

</style>
